function getOldestTransactionDate(transactions) {
    if (!transactions || transactions.length === 0) {
        return null;
    }
    var oldestTransaction = transactions.reduce(function (previous, current) {
        return current.TimestampEpoch < previous.TimestampEpoch ? current : previous;
    });
    return oldestTransaction.TimestampEpoch;
}

export { getOldestTransactionDate };
